import React from 'react';
import { Stack } from '@mui/material';
import { ICONIFY } from '../../../Constants/iconify';
import CommonNode from './CommonNode';
import NodeWrapper from './NodeWrapper';


function CalendarNode({ data, isConnectable }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <CommonNode
                data={data}
                icon={ICONIFY.CALENDAR}
            />
        </NodeWrapper>
    );
};

export default CalendarNode